import { useGameChallengeAlert } from "./use-game-challenge-alert";

/**
 * Headless app-wide listener for PvP arena alerts (challenge received / match
 * found / challenge declined). Mount once in the authenticated layout; it renders
 * nothing and drives toasts, the Notifications API, and the Web Audio jingle via
 * {@link useGameChallengeAlert}.
 */
export function GameAlertListener(): null {
  useGameChallengeAlert();
  return null;
}

export default GameAlertListener;
